import AMapLoader from '@amap/amap-jsapi-loader';
const install = (Vue) => {
   
    AMapLoader.load({
        // key: '3c64ca03666d92748bab5926802b0c9e', // key
        // key: '4600bb016736c56643f662972136648b', // 轨迹
        // key: '01cf5db72f3bf2e6bc35f015095aebe0', // 轨迹web服务
        // key: '01cf5db72f3bf2e6bc35f015095aebe0', // 轨迹web服务
        key: 'a72da1844816044f9dcc59c299082c1d', // 轨迹web服务
        plugins: ["AMap.Geocoder",'Map3D'], // 插件
        version:'2.0',
        Loca:{                // 是否加载 Loca， 缺省不加载
            "version": '2.0.0'  // Loca 版本，缺省 1.3.2
        },
    }).then((amap,b)=>{
        Vue.prototype.$Amap = amap
        window.Amap = amap
    }).catch(err=>{
        throw(new Error('加载高德地图失败：'+err,))
    })
}

export default {
    install,
}



// WEBPACK FOOTER //
// ./src/utils/amap.js